
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uniqueId;
let uid = 0;

function uniqueId() {
    return uid++;
}